import React from 'react';
//import { auth, db } from "./firebase";
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard.jsx';
//import Modulo from './modules/Modulo';
import Signup from './pages/Signup';
import SkillBuilder from './pages/SkillBuilder.jsx';
import ModulePage from './modules/ModulePage.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import ResourceAccessPrompt from './components/ResourceAccessPrompt.jsx';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <Routes>
        {/* rotas públicas */}
        <Route path="/" element={<Home />} />
        <Route path="/como-acessar" element={<ResourceAccessPrompt />} />
        <Route path="/como-acessar/:resourceId" element={<ResourceAccessPrompt />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* wrapper de rotas protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/skillbuilder" element={<SkillBuilder />} />
          <Route path="/modulo/:moduleId" element={<ModulePage />} />
          {/* adicione aqui todas as outras rotas que exigem login */}
        </Route>

        {/* rota “catch‑all” 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;